import React, { useState,useEffect,useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Navbar, Container, Nav, Form} from 'react-bootstrap'; // Import Bootstrap components
import Button from '@mui/material/Button';

import { AuthContext } from '../AuthProvider'; // Import the AuthContext from your AuthProvider

function SignUpPage() {
  const { isAuthenticated } = useContext(AuthContext); // Access isAuthenticated from the AuthContext
  const navigate = useNavigate(); // Initialize the navigate function
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  // useEffect(() => {

  //   try {
  //     if (isAuthenticated) {
  //       // If not authenticated, navigate to the login page
  //       navigate('/dashboard');
  //       return;
  //     }
  //   }
  //   catch (error) {
  //     setError('Failed to fetch links. Please try again later.');
     
  //   };
  // }, [isAuthenticated, navigate]); 

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Send a POST request to your backend signup endpoint
      const response = await fetch('https://urlshortener-serverside.onrender.com/api/auth/signup', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        // Redirect to login page after successful signup
        window.location.href = '/login';
      } else {
        const data = await response.json();
        console.error('Signup failed:', data.error);
        // Handle signup failure (e.g., display error message to the user)
      }
    } catch (error) {
      console.error('Error during signup:', error);
    }
  };

  return (
    <div>
    

      <div className="container mt-4">
        <h2>Signup</h2>
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="username">
            <Form.Label>Username</Form.Label>
            <Form.Control
              type="text"
              name="username"
              value={formData.username}
              onChange={handleChange}
              required
            />
          </Form.Group>
          <Form.Group controlId="email">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </Form.Group>
          <Form.Group controlId="password">
            <Form.Label>Password</Form.Label>
            <Form.Control
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
            />
          </Form.Group>
          <Button variant="primary" type="submit">
            Signup
          </Button>
        </Form>
      </div>
    </div>
  );
}

export default SignUpPage;